import * as Sentry from "@sentry/nextjs";
import React, { FC, ReactNode, useEffect } from "react";

import { useFetchCurrentAccountQuery } from "src/entities/account/document.gen";

export const SentryProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { data } = useFetchCurrentAccountQuery({
    fetchPolicy: "cache-only",
  });

  const currentAccountId = data?.currentAccount?.id;

  useEffect(() => {
    Sentry.setUser(currentAccountId ? { id: currentAccountId } : null);
  }, [currentAccountId]);

  return <>{children}</>;
};
